import { render, staticRenderFns } from "./BaseAnnexView.vue?vue&type=template&id=0a10f138&scoped=true&"
import script from "./BaseAnnexView.vue?vue&type=script&lang=js&"
export * from "./BaseAnnexView.vue?vue&type=script&lang=js&"
import style0 from "./BaseAnnexView.vue?vue&type=style&index=0&id=0a10f138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10f138",
  null
  
)

export default component.exports